import * as yup from "yup";

export const rateSchema = yup.object().shape({
  landingDayRate: yup.string().required("Day landing rate is required"),
  landingNightRate: yup.string().required("Night landing rate is required"),
  parkingRate: yup.string().required("Parking rate is required"),
  // currency: yup.string().required("Parking rate is required"),
});
